import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { TrustedBy } from './components/TrustedBy';
import { ProblemSection } from './components/ProblemSection';
import { CapabilitiesSection } from './components/CapabilitiesSection';
import { PlatformArchitecture } from './components/PlatformArchitecture';
import { TrustScoreSection } from './components/TrustScoreSection';
import { SecuritySection } from './components/SecuritySection';
import { AboutSection } from './components/AboutSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-navy text-white font-sans selection:bg-teal selection:text-navy" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <TrustedBy data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <CapabilitiesSection data-id="element-6" />
        <PlatformArchitecture data-id="element-7" />
        <TrustScoreSection data-id="element-8" />
        <SecuritySection data-id="element-9" />
        <AboutSection data-id="element-10" />
        <CTASection data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}